import { Component } from "react"
import Locale from "../../../utils/Locale"
import ModalStyle from "./Modal.module.scss"
import FlexStyle from "../../../scss/Flexes.module.scss"
import ContainerStyle from "../../../scss/Containers.module.scss"
import Button from "../Button/Button"

import * as ReactDOM from 'react-dom';
class Modal extends Component {
	render() {
		if (!this.props.show) return null;
		const heightClass = this.props.height ? ModalStyle.Height : ModalStyle.Fit;
		return ReactDOM.createPortal(
			<div data-modal="true" className={`${ModalStyle.Modal} ${ModalStyle.Show} ${heightClass}`}>
				<div className={ModalStyle.ModalContent}>
					{this.props.children}
					<div className={`${FlexStyle.FlexRowCenter} ${ContainerStyle.ButtonContainer}`}>
						<Button onClick={this.props.handleClose} text={Locale.GetMessages("Close")} />
						{this.props.buttons}
					</div>
				</div>
			</div>,
			document.getElementById("root")
		)
	}
}
export default Modal